import { useContext, useMemo } from 'react'

import { OptimizelyContext } from '@optimizely/react-sdk'
import { useSelector } from 'react-redux'

import { useDeliveryDateDiscount } from 'hooks/promotions/useDeliveryDateDiscount'
import { isBasketTransactionalOrder } from 'selectors/basket'

import type { DiscountBadge } from './buildDiscountBadge'
import { buildDiscountBadge } from './buildDiscountBadge'

const DISCOUNT_BADGE_FLAG = 'tomatoes_ofx_webclient_discount_visibility_menu'

export type OrderDetailsDiscount = {
  badge: DiscountBadge | null
  // True once eligibility has resolved, so callers can wait for the real answer.
  isSettled: boolean
}

export const useDiscountBadge = ({ enabled }: { enabled: boolean }): OrderDetailsDiscount => {
  const { optimizely } = useContext(OptimizelyContext)
  const isTransactional = useSelector(isBasketTransactionalOrder)

  const flagEnabled = useMemo(
    () => (optimizely && enabled ? optimizely.decide(DISCOUNT_BADGE_FLAG).enabled : false),
    [optimizely, enabled],
  )

  const { discount, isLoading } = useDeliveryDateDiscount({
    enabled: enabled && flagEnabled,
    boxType: isTransactional ? 'transactional' : 'subscription',
  })

  return {
    badge: discount ? buildDiscountBadge(discount) : null,
    isSettled: !isLoading,
  }
}
